module.exports = __webpack_public_path__ + "img/shard-on.050480ae.png";